import {
  GET_FOLLOWING_TRIBUN_USERS_REQUEST,
  GET_FOLLOWING_TRIBUN_USERS_SUCCESS,
  GET_FOLLOWING_TRIBUN_USERS_FAILURE,
  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,
  LIKE_OR_UNLIKE_COUPON_REQUEST,
  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  LIKE_OR_UNLIKE_COUPON_FAILURE,
  RESET_TRIBUN_TAB,
  SEND_COMMENT_REQUEST,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,
  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  COMMENT_FORBID_ALLOW_REQUEST,
  COMMENT_FORBID_ALLOW_SUCCESS,
  COMMENT_FORBID_ALLOW_FAILURE,
  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS
} from 'Store/constants';

import {
  likeOrUnlikeStoreStateChanger,
  followTribunUserStateChanger,
  sendCommentStoreStateChanger,
  deleteCommentStoreStateChanger,
  commentForbiddenStoreStateChanger,
  shareOrHideStoreStateChanger
} from 'Utils/tribunStoreHelpers';
import EnvironmentManager from 'Utils/environmentManager';

const initialState = {
  data: [],
  isLoading: null,
  lastPage: false,
  error: null
};

export default (state = initialState, action ) => {
  switch (action.type) {

    case GET_FOLLOWING_TRIBUN_USERS_REQUEST:
      return { ...state, isLoading: true, error: null };

    case RESET_TRIBUN_TAB:
      return { ...initialState };

    case GET_FOLLOWING_TRIBUN_USERS_SUCCESS:
      return {
        ...state,
        data: [...state.data, ...action.payload],
        lastPage: action.payload.lastPage,
        isLoading: false, error: null
      };
    case GET_FOLLOWING_TRIBUN_USERS_FAILURE: {
      const error = !state.data.length ? EnvironmentManager.getMessageText({ key: 'tribun_takip_ettiklerim' }) : action.payload;

      return {
        ...state,
        lastPage: action.lastPage,
        isLoading: false,
        error: error
      };
    }
    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FOLLOW_TRIBUN_USER_SUCCESS:
    {
      if (action.tabType === 'following') {
        state = followTribunUserStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ... state, isLoading: false, error: action.payload };

    case LIKE_OR_UNLIKE_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LIKE_OR_UNLIKE_COUPON_SUCCESS:
    {
      if (action.tabType === 'following') {
        state = likeOrUnlikeStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case LIKE_OR_UNLIKE_COUPON_FAILURE:
      return { ... state, isLoading: false, error: action.payload };

    case SEND_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SEND_COMMENT_SUCCESS:
    {
      if (action.tabType === 'following') {
        state = sendCommentStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case SEND_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_COMMENT_SUCCESS:
    {
      if (action.tabType === 'following') {
        state = deleteCommentStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case DELETE_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case COMMENT_FORBID_ALLOW_REQUEST:
      return { ...state, isLoading: true, error: null };
    case COMMENT_FORBID_ALLOW_SUCCESS:
    {
      if (action.tabType === 'following') {
        state = commentForbiddenStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case COMMENT_FORBID_ALLOW_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SHOW_OR_HIDE_COUOPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHOW_OR_HIDE_COUOPON_SUCCESS:
    {
      if (action.tabType === 'following') {
        state = shareOrHideStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    default:
      return state;
  }
};
